import { useEffect, useState } from 'react';

const Signin = () => {
    const [showModal, setShowModal] = useState(false);
    const isFromCollection = window.location.pathname.includes('/collection');
    const redirectToParameter = new URLSearchParams(window.location.search).get('redirectTo');
    const routeAfterSignin = redirectToParameter || window.location.href;
    const locale = document.documentElement.lang || 'en';

    useEffect(() => {
        const handleOpenSignin = () => {
            setShowModal(true);
        };
        document.addEventListener('open_signin_popup', handleOpenSignin);

        return () => {
            document.removeEventListener('open_signin_popup', handleOpenSignin);
        };
    }, []);

    useEffect(() => {
        if (showModal) {
            const routeAuth0 = routeAfterSignin.includes('collection')
                ? `/auth/${locale}/collection/redirect?state=${encodeURIComponent(routeAfterSignin)}`
                : `/auth/${locale}/redirect?state=${encodeURIComponent(routeAfterSignin)}`;

            window.location.href = routeAuth0;
        }
    }, [showModal, routeAfterSignin, locale, isFromCollection]);

    return null;
};

export default Signin;
